import { BATHROOM_CDN_PATH } from '../../old-bathroom-constants';
import { AdviceSectionDataStructure } from './advice-section-types';

export const ADVICE_SECTION_DATA: AdviceSectionDataStructure[] = [
  {
    href: '/advice/plitka/kak-ulozhit-plitku-na-stenu/',
    src: `${BATHROOM_CDN_PATH}/advice/1.jpg/1.jpg`,
    title: 'advice-section.advice-first',
  },
  {
    href: '/advice/santehnika/kak-ustanovit-tumbu-s-rakovinoy/',
    src: `${BATHROOM_CDN_PATH}/advice/2.jpg/2.jpg`,
    title: 'advice-section.advice-second',
  },
  {
    href: '/advice/santehnika/kak-ustanovit-vannu/',
    src: `${BATHROOM_CDN_PATH}/advice/3.jpg/3.jpg`,
    title: 'advice-section.advice-third',
  },
];
